import gantt from 'dhtmlx-gantt';

/**
 * dhtmlx: `getGanttInstance()` returns a root-scoped API; package typings target the default singleton only.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DhtmlxGanttInstance = any;

export function getGanttSingleton(): DhtmlxGanttInstance {
    const globalSingleton = (globalThis as { gantt?: DhtmlxGanttInstance }).gantt;
    if (globalSingleton && typeof globalSingleton === 'object') {
        return globalSingleton;
    }

    return gantt as DhtmlxGanttInstance;
}

export function getGanttInstanceFactory(): (() => DhtmlxGanttInstance) | null {
    const globalFactory = (globalThis as { Gantt?: { getGanttInstance?: () => DhtmlxGanttInstance } }).Gantt?.getGanttInstance;
    if (typeof globalFactory === 'function') {
        return globalFactory;
    }

    const localFactory = (gantt as typeof gantt & { getGanttInstance?: () => DhtmlxGanttInstance }).getGanttInstance;
    if (typeof localFactory === 'function') {
        return localFactory;
    }

    return null;
}
